import React from 'react';
export function AddCircleIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 11h-2V9a1 1 0 00-2 0v2H9a1 1 0 000 2h2v2a1 1 0 002 0v-2h2a1 1 0 000-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.015 2H12a10 10 0 10-.015 20H12a10 10 0 00.015-20zM12 20h-.012A8 8 0 0112 4h.012A8 8 0 0112 20z"
  }));
}